import { makeAutoObservable } from 'mobx'

import type { CrmViolation } from './CrmVerification'

/**
 * Незаповнені вимоги верифікації, які ще треба показати в картці.
 *
 * Навіщо окремий стор: на 422 вимог картка переходить у редагування
 * ядровим `actions.edit` — а це **нова** картка з власною формою, яка
 * завантажує запис наново (`ResourceDetail.loadResourceData` починає з
 * `formContext.reset()`, тож помилки, поставлені старій формі, пропали б).
 * Тому кнопки кладуть порушення сюди за ключем запису, а картка в режимі
 * редагування забирає їх, щойно намалювалася (`VerificationRequirementsAlert`).
 *
 * Запис не видаляється при показі: картку може бути перемальовано (повторне
 * завантаження), і поля мають підсвітитися знову. Його замінює наступна 422
 * або прибирає успішний перехід. Застарілий запис не шкодить — перелік
 * показує лише поля, на яких помилка ще стоїть.
 */
class VerificationRequirementsStore {
    private byOwner = new Map<string, CrmViolation[]>()

    constructor() {
        makeAutoObservable(this)
    }

    set(ownerKey: string, violations: CrmViolation[]): void {
        this.byOwner.set(ownerKey, [...violations])
    }

    get(ownerKey: string): CrmViolation[] | null {
        return this.byOwner.get(ownerKey) ?? null
    }

    forget(ownerKey: string): void {
        this.byOwner.delete(ownerKey)
    }
}

export const verificationRequirements = new VerificationRequirementsStore()

/** Ключ запису власника: колекція + uuid (`/services/clients/019…`). */
export const verificationOwnerKey = (restUrl: string, uuid: string): string => `${restUrl}/${uuid}`
